import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../index.d'

export const accEntryAddByAction = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] ADD_BY_ACTION',
  async ({ action, ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.add(action, params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accEntryAdd = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] ADD',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.add('add', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accEntryConvAddEdit = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] CONV_ADD',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.addOper(params.action, params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)

export const accEntryEdit = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] EDIT',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.add('edit', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accEntryConvEdit = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] CONV_EDIT',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.addOper('edit', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accEntryDelete = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] DELETE',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.add('delete', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accEntryConcDelete = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] CONV_DELETE',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.addOper('delete', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)
